import type { LocKey } from "src/translations";

export type NotificationsState = Readonly<{
    show: boolean;
    title: string | null;
    titleKey: LocKey | null;
    text: string | null;
    textKey: LocKey | null;
    type: NotificationType | null;
    isCloseable: boolean;
    data: Record<string, string>;
}>;

export enum NotificationType {
    SUCCESS = "success",
    INFO = "info",
    WARNING = "warning",
    ERROR = "error",
}

export type AlertActionPayload = {
    text: string;
    component?: React.JSX.Element;
};

export interface ExtendedAlertActionPayload extends AlertActionPayload {
    id?: string;
    name?: string;
}

export type AlertProps = Readonly<{
    description: string;
    show?: boolean;
    title?: string;
    titleKey?: string | null;
    text?: string;
    textKey?: string;
    type?: NotificationType;
    isCloseable?: boolean;
    data?: Record<string, string>;
    args?: string;
    action?: React.ReactNode;
}>;
